import { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '@/App';
import { useConsent } from '@/lib/consent';

const GoogleAdsTracking = () => {
  const [googleAdsId, setGoogleAdsId] = useState(null);
  const { consent } = useConsent();
  const allowed = !!(consent && consent.ads);

  // Einstellungen erst abrufen und das Google-Tag erst laden, wenn eingewilligt wurde
  useEffect(() => {
    if (!allowed) {
      setGoogleAdsId(null);
      return;
    }
    fetchGoogleAdsSettings();
  }, [allowed]);

  const fetchGoogleAdsSettings = async () => {
    try {
      const response = await axios.get(`${API}/settings/contact`);
      if (response.data.google_ads_id) {
        setGoogleAdsId(response.data.google_ads_id);
      }
    } catch (error) {
      console.error('Error fetching Google Ads settings:', error);
    }
  };

  useEffect(() => {
    if (!googleAdsId) return;

    // Add Google Ads gtag.js script
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${googleAdsId}`;
    document.head.appendChild(script1);

    // Add gtag config script
    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${googleAdsId}');
    `;
    document.head.appendChild(script2);

    // Cleanup
    return () => {
      document.head.removeChild(script1);
      document.head.removeChild(script2);
    };
  }, [googleAdsId]);

  return null; // This component doesn't render anything
};

export default GoogleAdsTracking;
